export const LOGIN = '/login';
export const CONTEXT = '/context';
export const TRANSLATIONS = '/translations';
export const WS_TOKEN = '/wsToken';

export const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_BASE_URL;
export const WS_BASE_URL = import.meta.env.VITE_REACT_APP_WSOCKET_BASE_URL;
export const FONT_ICON_URL = `${import.meta.env.VITE_REACT_APP_ASSETS_URL}/public/themes/default/font-icons/fb-icon.css`;
